import { theme } from './theme';
export * from './theme';
export * from './components';
export { GlobalSearchInput } from '../common/GlobalSearchInput';
export type { GlobalSearchInputProps } from '../common/GlobalSearchInput';

// Export utility functions for consistent styling
export const cn = (...classes: (string | undefined | null | false)[]): string => {
  return classes.filter(Boolean).join(' ');
};

// Professional color palette utilities
export const colors = {
  primary: {
    light: theme.colors.primary[100],
    DEFAULT: theme.colors.primary[500],
    dark: theme.colors.primary[800],
  },
  secondary: {
    light: theme.colors.secondary[100],
    DEFAULT: theme.colors.secondary[500],
    dark: theme.colors.secondary[900],
  },
  success: {
    light: theme.colors.success[100],
    DEFAULT: theme.colors.success[500],
    dark: theme.colors.success[900],
  },
  warning: {
    light: theme.colors.warning[100],
    DEFAULT: theme.colors.warning[500],
    dark: theme.colors.warning[900],
  },
  error: {
    light: theme.colors.error[100],
    DEFAULT: theme.colors.error[500],
    dark: theme.colors.error[900],
  },
  neutral: theme.colors.neutral,
};

// Responsive breakpoints
export const breakpoints = theme.breakpoints;

// Animation utilities
export const animations = {
  fadeInScale: 'fade-in-scale 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  slideUp: 'slide-up 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  pulseSoft: 'pulse-soft 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
  shimmer: 'shimmer 1.5s infinite',
};

// Shadow utilities
export const shadows = {
  soft: '0 2px 15px -3px rgba(0, 0, 0, 0.07), 0 10px 20px -2px rgba(0, 0, 0, 0.04)',
  elevated: '0 10px 40px -10px rgba(0, 0, 0, 0.1), 0 20px 30px -15px rgba(0, 0, 0, 0.08)',
  card: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
};

// Gradient utilities
export const gradients = {
  primary: 'linear-gradient(135deg, var(--crm-primary, #574c99), var(--crm-gradient-end, #45376f))',
  secondary: 'linear-gradient(135deg, var(--crm-primary, #574c99), var(--crm-gradient-end, #45376f))',
  success: 'linear-gradient(135deg, var(--crm-primary, #574c99), var(--crm-gradient-end, #45376f))',
  warm: 'linear-gradient(135deg, var(--crm-primary, #574c99), var(--crm-gradient-end, #45376f))',
  cool: 'linear-gradient(135deg, var(--crm-primary, #574c99), var(--crm-gradient-end, #45376f))',
};

export { LocalizedNameFields } from '../common/LocalizedNameFields';
export type { LocalizedNameFieldsProps } from '../common/LocalizedNameFields';
export { useCrmLocale } from '../../ui/locale/crmLocale';
export { translateKey, formatLocaleDate, formatLocaleNumber } from '../../ui/locale/centralLocalization';
